// extracted by mini-css-extract-plugin
module.exports = {"unlinkIcon":"LinkMetamask_unlinkIcon__2JNpi"};